import { css, keyframes } from "@compiled/react";

export const FireSvg = ({ progress }: { progress: number }) => (
    <svg
        css={[shake, progress > 0.8 && explode]}
        width="41"
        height="41"
        viewBox="0 0 41 41"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_3274_21797)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M34.8786 28.7439C28.0017 35.6208 18.3396 40.2306 2.29713 39.8851C1.94087 23.8427 6.55064 14.1913 13.4383 7.30366C19.743 0.998959 29.5563 -0.361302 39.4452 2.72627C42.5328 12.6151 41.1833 22.4285 34.8678 28.7332L34.8786 28.7439Z"
                fill="#FCA700"
            />
        </g>
        <defs>
            <clipPath id="clip0_3274_21797">
                <rect width="41" height="41" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

const explodeKeyframes = keyframes({
    "0%": {
        transform: "scale(2) rotate(0deg) translateX(0px) translateY(3px)"
    },
    "25%": {
        transform: "scale(2) rotate(0deg) translateX(3px) translateY(0px)"
    },
    "50%": {
        transform: "scale(2) rotate(0deg) translateX(0px) translateY(-3px)"
    },
    "75%": {
        transform: "scale(2) rotate(0deg) translateX(-3px) translateY(0px)"
    },
    "100%": {
        transform: "scale(2) rotate(0deg) translateX(0px) translateY(3px)"
    }
});

const explode = css({
    insetBlockStart: -24,
    insetInlineEnd: 25,
    animation: `${explodeKeyframes} 0.4s infinite`
});

const jiggleKeyframes = keyframes({
    "0%": {
        transform: "rotate(0deg) translateX(0px) translateY(3px)"
    },
    "25%": {
        transform: "rotate(0deg) translateX(3px) translateY(0px)"
    },
    "50%": {
        transform: "rotate(0deg) translateX(0px) translateY(-3px)"
    },
    "75%": {
        transform: "rotate(0deg) translateX(-3px) translateY(0px)"
    },
    "100%": {
        transform: "rotate(0deg) translateX(0px) translateY(3px)"
    }
});

const shake = css({
    mixBlendMode: "multiply",
    display: "block",
    position: "relative",
    insetBlockStart: -40,
    insetInlineEnd: 7,
    transition: "all 0.5s ease-in-out",
    animation: `${jiggleKeyframes} 0.4s infinite`
});
